import {break_md} from "../../js/constants";

[].forEach.call(document.querySelectorAll('.faqWrapper'), item => {
  const side = document.querySelector('.faqWrapper__side');
  const list = document.querySelector('.faq__list');
  if(!side) return;
  if(window.innerWidth < break_md) return;
  side.style.paddingTop = list.offsetTop + 'px';
});

